import { useEffect, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../Grid/Grid";
import { Card } from "react-bootstrap";
import EquipmentPreviewBlade from "./EquipmentPreviewBlade";
import { Eye, EyeFill } from "react-bootstrap-icons";
import EquipmentTaskListBlade from "./EquipmentTaskListBlade";
import { Button } from "../Button/Button";
import AllEquipmentTaskListBlade from "./AllEquipmentTaskListBlade";

interface propData {
    data: any;
    code: string;
    otherData: any;
}

const headers: GridHeader[] = [
    {
        title: "",
        class: 'text-center',
    },
    {
        title: "Manufacturer",
        class: 'text-center',
    },
    {
        title: "Model",
        class: 'text-center'
    },
    {
        title: "Serial #",
        class: 'text-center'
    },
    {
        title: "Location",
        class: 'text-center'
    },
    {
        title: "System",
        class: 'text-center'
    },
    {
        title: "Unit",
        class: 'text-center'
    },
    {
        title: "Action",
        class: 'text-center'
    },
];

const InvoiceDetailEquiment = (props: propData) => {
    const [rows, setRows] = useState<GridRow[]>([]);
    const [showModal, setShowModal] = useState(false)
    const [selectedData, setSelectedData] = useState<any>()
    const [showTasklistModel, setShowTasklistModel] = useState(false);
    const [selectedEquipment, setSelectedEquipment] = useState('');
    const [tasklistType, setTasklistType] = useState('');
    const [allEquipmentData, setAllEquipmentData] = useState([]);
    const [isShowAllTasklistBlade, setShowAllTasklistBlade] = useState(false);

    useEffect(() => {
        getEquipments()
    }, [])

    const getEquipments = () => {
        if (props.data.equipments && props.data.equipments.length > 0) {
            setAllEquipmentData(props.data.equipments)
            let rows: GridRow[] = [];
            for (var i in props.data.equipments) {
                let columns: GridColumn[] = [];
                columns.push({ value: renderImage(props.data.equipments[i]) });
                columns.push({ value: props.data.equipments[i].eqpManufacturer });
                columns.push({ value: props.data.equipments[i].modelNum });
                columns.push({ value: props.data.equipments[i].serialNum });
                columns.push({ value: props.data.equipments[i].eqpLocation });
                columns.push({ value: props.data.equipments[i].eqpSystem });
                columns.push({ value: props.data.equipments[i].unitNum });
               // columns.push({ value: action(props.data.equipments[i]) });
                rows.push({ data: columns, type: 'A', backgroundColor: props.data.equipments[i].bg, textColor: props.data.equipments[i].tc });

                let columns2: GridColumn[] = [];
                columns2.push({ value: props.data.equipments[i].eqpDescription });
                rows.push({ data: columns2, type: 'B', backgroundColor: props.data.equipments[i].bg, textColor: props.data.equipments[i].tc });
            }
            setRows(rows);
        }
    }

    const renderImage = (data: any) => {
        return (
            <img src={data.eqpImageURL} height={60} width={60} style={{ width: '100%' }} onClick={() => {
                setSelectedData(data.eqpImageURL)
                setShowModal(true)
            }} />
        )
    }

    const action = (data: any) => {
        return (
            <>
                <div onClick={() => {
                    setSelectedEquipment(data)
                    setShowTasklistModel(true)
                }} className='cursor-pointer'>
                    <EyeFill />
                </div>
            </>
        )
    }

    const onCloseModal = () => {
        setShowModal(false)
    }

    return (
        <>
            {showTasklistModel && <EquipmentTaskListBlade
                isShow={showTasklistModel}
                isClose={() => {
                    setShowTasklistModel(false)
                    setTasklistType('')
                }}
                data={props.data}
                code={props.code}
                id={selectedEquipment}
                type={tasklistType}
                otherData={props.otherData}
            />}
            <AllEquipmentTaskListBlade
                isShow={isShowAllTasklistBlade}
                isClose={() => {
                    setShowAllTasklistBlade(false)
                    setTasklistType('')
                }}
                data={props.data}
                code={props.code}
                id={selectedEquipment}
                type={tasklistType}
                otherData={props.otherData}
            />
            <EquipmentPreviewBlade
                isShow={showModal}
                isClose={onCloseModal}
                data={selectedData}
            />
            <Card className="card-style form-style invoice-call-picture-card p-3" style={{ marginBottom: 50 }}>
                <div className="download-all-button">
                    <div className="download-buttons" onClick={() => {
                        // setTasklistType('ALL')
                        setShowAllTasklistBlade(true)
                    }}>
                        View All Tasklist
                    </div>
                </div>
                <Grid
                    headers={headers}
                    rows={rows} />
            </Card>
        </>
    )
}

export default InvoiceDetailEquiment;